export const listPersonas = `
   query listPersonas($filter: PersonasFilterInput, $limit: Int, $nextToken: String) {
       listPersonas(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              name
              description
              actionCodes {
                actionCode
                weight
              }
              testDefinitionIds
              lifecycle {
                wakeCadenceHours
                expectedLifespanDays
                cancellationLikelihoodPercent
              }
              createdByUsername
              updatedByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getPersona = `
   query getPersona($id: ID!) {
       getPersona(id: $id) {
         id
         name
         description
         actionCodes {
           actionCode
           weight
         }
         testDefinitionIds
         lifecycle {
           wakeCadenceHours
           expectedLifespanDays
           cancellationLikelihoodPercent
         }
         createdByUsername
         updatedByUsername
         created
         updated
       }
}`;
